import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SeniorComponent } from './senior.component';
import { SeniorHomeComponent } from './components/home/senior-home.component';
import { SeniorAttachedComponent } from './components/attached/senior-attached.component';
import { SeniorRankingComponent } from './components/ranking/list/senior-ranking.component';
import { SeniorRankingClassifComponent } from './components/ranking/classification/senior-ranking-classif.component';
import { SharedAttachmentsDetailComponent } from '@theme/components';

const routes: Routes = [
    {
        path: '',
        component: SeniorComponent,
        children: [
            { path: 'home', component: SeniorHomeComponent },
            {
                path: 'tournament',
                loadChildren: () => import('../tournament/tournament.module').then((m) => m.TournamentModule),
            },
            { path: 'ranking-2', loadChildren: () => import('../ranking/ranking.module').then((m) => m.RankingModule) },
            { path: 'ranking', component: SeniorRankingComponent },
            {
                path: 'ranking-classif/:rankingId',
                component: SeniorRankingClassifComponent,
            },
            {
                path: 'attached/:sessionType',
                component: SeniorAttachedComponent,
            },
            { path: 'attached/:sessionType/detail/:docId', component: SharedAttachmentsDetailComponent },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class SeniorRoutingModule {}
